/**
 * Apply the Design System to a single Drupal behavior
 */
import { enableAllComponents } from '../source';

require('./scss/_drupal-styles.scss');

if (module.hot) {
  module.hot.accept()
}

Drupal.behaviors.designSystem = {
  attach($context, settings) {
    // Provide overrides to components from Drupal settings
    const componentSettings = {
    };

    // Now enable all components with a custom componentSettings object
    enableAllComponents($context, componentSettings);
  },
};
